import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../../context/authContext.js";
import "./Submission4Student.css";
import Problem from "../../ProblemLayout/Problem";
import Keyboard from "./Keyboard/Keyboard.jsx";

import { GettingProblemByReferenceCode } from "../../../Functions/CRUD/Problem/problemHelper";
import {
  DeleteSession,
  GettingSubmission,
  UpdateSubmission,
} from "../../../Functions/CRUD/Submission/submissionHelper";
import Error404Layout from "../../../Error/Error404/Error404Layout";
import LoadingPage from "../../../Error/LoadingPage/LoadingPage";
import StudentWork from "./StudentWork/StudentWork.jsx";
import CommentSection from "./CommentSection/CommentSection.jsx";

const Submission4Student = () => {
  const { referenceCode } = useParams();
  console.log(referenceCode)
  const [Submission, setSubmission] = useState(null);
  const [problem, setproblem] = useState(null);
  const [Error, setError] = useState(null);
  const [ErrorMessage, setErrorMessage] = useState(
    "Loding page in process ..."
  );
  const [Loading, setLoading] = useState(null);
  const { user } = useContext(AuthContext);

  /* Fetching problem */

  const fetchProblem = async () => {
    try {
      const data = await GettingProblemByReferenceCode(referenceCode);
      if (!data.found) {
        setError(404);
        setErrorMessage(data.status);
        setLoading(false);
        return; // stop further processing
      }
      setproblem(data.Problem);
      setLoading(false)
    } catch (err) {
      setError("Problem fetch failed");
    }
  };

  /* Getting Submission */

  const fetchSubmission = async () => {
    try {
      const data = await GettingSubmission(referenceCode, user?._id, {});
      if (data.found) {
        setSubmission(data.data);
      } else {
        setSubmission(null);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* useEffects */

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      await fetchProblem();
    };
    init();
  }, [referenceCode]);

   useEffect(() => {
    if (problem && problem.status.toLowerCase() === "live" && user?._id) {
      fetchSubmission();
    }
  }, [problem, user?._id]);

    if (Loading) return <LoadingPage />;

  if (Error === 404) return <Error404Layout />;

  if (Error) return <div>{Error}</div>;

  if (!problem) return <LoadingPage />;

  if (problem.status.toLowerCase() === "archived") {
    return (
      <div className="Submission-Conatiner">
        <Problem problem={problem} PassDue={true} />
        <hr />
        <p style={{color : "red", marginTop : "3vh" }}> This problem is archived, meaning you can no longer submit a solution regarding this topic.
          Feel free to check the solution of the problem by hitting "Explore" button. Stay aware of problem submission deadLines so that you won't miss out. Solve safe !</p>
      </div>
    );
  }

  return (
    <div className="Submission-Conatiner">
      <Problem problem={problem} PassDue={true} />
      <hr />

      {!Submission ? (
        <div>
          <div className="HEader">
            <h1 className="Title">Update Your Submission : </h1>
          </div>
          <p>
            When submitting your work through the website, ensure you have
            selected the correct problem and entered all your answers in the
            required format. Double-check your solutions before clicking
            “Submit,” as changes may not be allowed afterward. Make sure your
            work is complete, clear, and free of typos.
          </p>
          
        </div>
      ) : (
        <div className="">
          <div className="HEader">
            <h1 className="Title">My Submission </h1>
            <span
                style={{
                  fontSize: "1.5em",
                  fontWeight: "600",
                  color:
                    Submission.result?.trim().toLowerCase() === "on hold"
                      ? "gray"
                      : Submission.result?.trim().toLowerCase() === "in process"
                      ? "#EDAB18"
                      : Submission.result?.trim().toLowerCase() === "correct"
                      ? "green"
                      : "red",
                }}
              >
                ( {Submission.result} )
              </span>
          </div>
          <div style={{ width: "97%", margin: "0 auto" }}>
            <StudentWork Submission={Submission?.discussion?.find(
                (item) => item.class === "Trial"
              )}/>
          </div>
          <div className="">
            <CommentSection comments={Submission?.discussion?.filter(
                  (item) => item.class === "comment"
                )} />

          </div>
        </div>
      )}
      {Submission?.result?.trim().toLowerCase()==="incorrect"?

        (
          <div className="BookSession-container">
                      <p style={{color : "red",padding : "1vh"}}>
                        This session was archived by your coordenator. You may start a new session, along with deleting this session.
                      </p>
                      <button
                        className="BookSession"
                        onClick={async () => {
                          try {
                            const response = await DeleteSession (referenceCode,user._id)
                            
                            
                            window.location.reload();
                          } catch (error) {
                            console.error("Error deleting submission:", error);
                          }
                        }}
                      >
                        - Try Again -
                      </button>
                    </div>
 
        )
        : Submission?.result?.trim().toLowerCase()==="correct"? 
        (
          <div>
            <hr />
          <p style={{color : "green",padding : "1vh"}}>This session was archived by your coordenator, granting you a full solution for the problem. Well Done! </p>
          </div>
        ):
        (<Keyboard
            poster={user}
            TypeOfPost={Submission?"comment":"Trial"}
            Tried={Submission?true:false}
            referenceCode={referenceCode}
            
          />)}
    </div>
  );
};

export default Submission4Student;
